export const StoreType = {
  AUTH: "AUTH",
  AUTH_TOKEN: "AUTH_TOKEN",
  USER: "USER",
  ROLE: "ROLE",
  THEME: "THEME",
  LANGUAGE: "LANGUAGE",
  NOTIFICATION: "NOTIFICATION",
};

const saveToStore = (data: unknown, key: string) => {
  let value: string;

  if (Array.isArray(data) || (typeof data === "object" && data !== null)) {
    value = JSON.stringify(data);
  } else if (
    typeof data === "string" ||
    typeof data === "number" ||
    typeof data === "boolean"
  ) {
    value = String(data);
  } else {
    console.warn("Unsupported data type for localStorage");
    return;
  }

  localStorage.setItem(key, value);
};

const getFromStore = <T>(key: string): T | null => {
  const value = localStorage.getItem(key);
  if (value === null) return null;

  try {
    return JSON.parse(value) as T;
  } catch {
    return value as unknown as T; // If it's a primitive (string, number, boolean)
  }
};

export { getFromStore, saveToStore };
